export const BaseURL = process.env.NODE_ENV === 'production' ? 'https://backend.bhcollege.ac.in/public' : 'http://localhost/bhcollege/api/public';


// WEBPACK FOOTER //
// ./src/helper/GlobalConstants.js